<div class="chat-container">
  <!-- Chat Header -->
  <dc-chat-header
    [agentCard]="agentCard"
    [isAdmin]="isAdmin"
    (showInfoEvent)="showInfo()"
    (settingsClickEvent)="changeUserChatSettings()"
    (restartConversationEvent)="restartConversation($event)"
    (completeEvent)="complete()">
  </dc-chat-header>

  <!-- Messages List -->
  <dc-chat-messages-list [chatUserSettings]="chatUserSettings" [inputMessages]="messages()"> </dc-chat-messages-list>

  <!-- Chat Footer -->
  <dc-chat-footer [micSettings]="micSettings" [flow]="conversationFlow"> </dc-chat-footer>

  <!-- Info Dialog -->
</div>
